const MainInfo = () => {
  return (
    <div className="space-y-4 text-gray-700">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Основные сведения</h2>
      <p><strong>Центр знаний «БезПробелов»</strong></p>
      <p><strong>Дата создания:</strong> 15 августа 2016 года</p>
      <p><strong>Учредитель:</strong> ИП Благодатская Ю.Ю.</p>
      <p><strong>Место нахождения:</strong> г. Калуга, ул. Кирова, д.20, офис 406 (пом. 12)</p>
      <p><strong>График работы:</strong> понедельник – пятница 15:00-20:00</p>
      <p><strong>Контактные телефоны:</strong><br/>8-962-177-70-75<br/></p>
      <p><strong>Email:</strong> Blagodatskaya-yu@mail.ru</p>
      <p><strong>Лицензия:</strong> серия 40Л01 №0001897 выдана Министерством образования и науки Калужской области 04 сентября 2019 года</p>
    </div>
  );
};

export default MainInfo;
